import FlightBillHandler from '@itinerary/trip/flight/FlightBillHandler';

export default class FlightAutoBillHandler extends FlightBillHandler {
    constructor() {
        super('', []);
    }

    override isAutoReserve = true;
    override prepayReservation() {
        return Promise.resolve();
    }
}
